import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Icon, IconName } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";
import { formatDate } from "@nju/utils";

interface IOrderStatusProps {
  status: string;
  transferDate: string | undefined;
  orchestratorState: IMobileOrchestrator["state"];
  iconName: IconName;
}

export function OrderStatus({
  status,
  transferDate,
  orchestratorState,
  iconName,
}: IOrderStatusProps) {
  const iconStyles = "mr-4 w-6 h-6 from-tablet:w-7 from-tablet:h-7";

  return (
    <div className="flex gap-10 only-mobile:flex-col only-mobile:gap-5">
      <div className="flex items-center">
        <Icon className={iconStyles} name={iconName} tone="accent" />
        <div className="flex-1">
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            status
          </Text>
          <BlockText
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "l",
            }}
            weight="bold"
          >
            {status}
          </BlockText>
        </div>
      </div>
      {transferDate &&
        [
          "ORDER_COMMITTED",
          "ORDER_FULFILLMENT",
          "SIM",
          "PAYMENT_METHOD",
        ].includes(orchestratorState) && (
          <div className="flex items-center">
            <Icon className={iconStyles} name="calendar" tone="accent" />
            <div className="flex-1">
              <Text
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "m",
                }}
              >
                planowana data przeniesienia
              </Text>
              <BlockText
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "l",
                }}
                weight="bold"
              >
                {formatDate(transferDate, false)}
              </BlockText>
            </div>
          </div>
        )}
    </div>
  );
}
